// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"f1cd2fec","11":"f1cd2fec","639":"6d75f2a1","717":"f1cd2fec","721":"f1cd2fec","803":"f1cd2fec","908":"f1cd2fec"}[chunkId] + ".chunk.css";
};